import cloneDeep from 'lodash/cloneDeep'
import unescape from 'lodash/unescape'
import { AccountTypes } from '@/constants/user/accountTypes'
import { CustomerTypes } from '@/constants/user/roles'
import Avatar from '@/models-ts/user/Avatar'
import { stripDescriptionTags } from '@/utils-ts/strings'
import { parseSlug } from '@/utils/parser'
import Skill from '../Skill'

export default class JobListItem {
  id: string
  slug: string
  name: string | null
  budget: string
  description: string | null
  publishedAt: string
  editedAt: string
  skills: Array<Skill>
  user: {
    id: number
    avatar: Avatar
    name: string
    avgReviews: number
    reviewsCount: number
    type: AccountTypes
    companyWebsite?: string | null
    individualWebsite?: string | null
    is_customer_verified: boolean
    customerProfile: CustomerTypes
  }
  constructor(data: Partial<JobListItem>) {
    Object.assign(this, cloneDeep(data))
  }

  get userWebsite() {
    return this.user.companyWebsite || this.user.individualWebsite
  }

  static fromServer(data: LX.JobListItem) {
    return new JobListItem({
      id: data.id,
      slug: parseSlug(data.slug),
      name: unescape(data.name),
      budget: data.budget,
      description: stripDescriptionTags(data.description, { stripLinks: true }),
      publishedAt: data.updated_at || data.created_at,
      editedAt: data.edited_at || data.created_at,
      skills: (data.skills || []).map(Skill.fromServer),
      user: {
        id: data.user.id,
        name: unescape(data.user.name),
        avatar: Avatar.fromServer(data.user.avatar),
        type: data.user.type,
        avgReviews: data.user.profile.avg_reviews,
        reviewsCount: data.user.reviews_count,
        companyWebsite: data.user.profile.company_website,
        individualWebsite: data.user.profile.individual_website,
        is_customer_verified: Number(data.user.is_customer_verified) === 1,
        customerProfile: data.user.profile.type,
      },
    })
  }

  static fromMoreServer(data: LX.JobMore) {
    return new JobListItem({
      id: data.id,
      slug: parseSlug(data.slug),
      name: unescape(data.name),
      budget: data.budget || '0.00',
      description: stripDescriptionTags(data.description, { stripLinks: true }),
      publishedAt: data.updated_at,
      editedAt: data.edited_at,
      skills: (data.skills || []).map(Skill.fromServer),
      user: {
        id: data.user.id,
        name: unescape(data.user.name),
        avatar: Avatar.fromServer(data.user.avatar),
        type: data.user.type,
        avgReviews: data.user.profile.avg_reviews,
        reviewsCount: data.user.reviews_count,
        companyWebsite: data.user.profile.company_website,
        individualWebsite: data.user.profile.individual_website,
        is_customer_verified: Number(data.user.is_customer_verified) === 1,
        customerProfile: data.user.profile.type,
      },
    })
  }
}
